import { IState } from 'shared/store';

export const selectTrackingUrl = (state: IState) => {
  return state.offerData.trackingUrl || '';
};
